import { useCallback, useState } from "react";

import type { SnackBlocksFormModelContentsMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/contents";

import { LayoutSettingsIslandContentRowEmptySnackItem } from "./empty-snack-item";
import { LayoutSettingsIslandContentRowSnackItem } from "./snack-item";

type Props = {
	hotelID: string;
	index: number;

	itemLength: number;
	blockUUID: string;

	snack: SnackBlocksFormModelContentsMethodsType["blocks"]["value"][number]["items"]["value"][number];

	contentsMethods: SnackBlocksFormModelContentsMethodsType;
};

export const useSelectSnackModalState = () => {
	// スナックを選択するモーダルの表示に関する処理
	const [isShowSelectSnackModal, setIsShowSelectSnackModal] = useState<boolean>(false);

	const activateSelectSnackModal = useCallback(() => {
		setIsShowSelectSnackModal(true);
	}, [setIsShowSelectSnackModal]);

	const deactivateSelectSnackModal = useCallback(() => {
		setIsShowSelectSnackModal(false);
	}, [setIsShowSelectSnackModal]);

	const handleOpenChangeSelectSnackModal = useCallback(
		(input: boolean) => {
			setIsShowSelectSnackModal(input);
		},
		[setIsShowSelectSnackModal],
	);

	return {
		isShowSelectSnackModal,
		activateSelectSnackModal,
		deactivateSelectSnackModal,
		handleOpenChangeSelectSnackModal,
	};
};

export const LayoutSettingsIslandContentRowSnackItemRoot = ({
	hotelID,
	blockUUID,
	itemLength,
	index,
	snack,
	contentsMethods,
}: Props) => {
	const heightTailwindStyle = itemLength === 1 ? "h-[19vw]" : itemLength === 2 ? "h-[14vw]" : "h-[12vw]";

	/**
	 * snackが選択されていないかどうか
	 */
	const snackNotSelected = "isEmpty" in snack || !snack.itemUUID.value;

	return (
		<>
			{snackNotSelected ? (
				<LayoutSettingsIslandContentRowEmptySnackItem
					hotelID={hotelID}
					index={index}
					blockUUID={blockUUID}
					snack={snack}
					contentsMethods={contentsMethods}
					heightTailwindStyle={heightTailwindStyle}
				/>
			) : (
				<LayoutSettingsIslandContentRowSnackItem
					hotelID={hotelID}
					index={index}
					blockUUID={blockUUID}
					snack={snack}
					contentsMethods={contentsMethods}
					heightTailwindStyle={heightTailwindStyle}
				/>
			)}
		</>
	);
};

LayoutSettingsIslandContentRowSnackItemRoot.displayName = "LayoutSettingsIslandContentRowSnackItemRoot";
